import { render, staticRenderFns } from "./proToChaNproToClose.vue?vue&type=template&id=744ee7f4&scoped=true&"
import script from "./proToChaNproToClose.vue?vue&type=script&lang=js&"
export * from "./proToChaNproToClose.vue?vue&type=script&lang=js&"
import style0 from "./proToChaNproToClose.vue?vue&type=style&index=0&id=744ee7f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744ee7f4",
  null
  
)

export default component.exports